import defer from 'lodash/defer';
import {
  getFavoriteVenues,
  observeStore,
  utils,
} from '@resy/ui-kitchen';
import {
  getResyLocationsSelectedThunk, setSelectedLocationThunk,
} from '../../../../ui-kitchen/src/reducers/resyLocationsSlice';
import {
  getSelectedCoreISODateThunk, getSelectedCoreSeatsThunk, setSelectedCoreISODate, setSelectedCoreSeats, setSelectedCoreTime,
} from '../../../../ui-kitchen/src/reducers/resyCoreSlice';
import { initObserveStore } from '../../../../ui-kitchen/src/utils';
import { ALL_DAY, ISO_DATE_FORMAT } from '../../../../ui-kitchen/src/constants/resyCore';
import { selectIsAuthenticated } from '../../../../ui-kitchen/src/reducers/authTokenSlice';
import { getTranslation } from '../../../../ui-kitchen/src/providers/TranslationProvider';

angular
  .module('resyApp')
  .component('resySearch', {
    templateUrl: 'components/search/search.html',
    controller: ResySearchController,
    controllerAs: 'vm',
  });

function ResySearchController(
  $location,
  $ngRedux,
  $rootScope,
  $route,
  $routeParams,
  $scope,
  $translate,
  $window
) {
  /* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["$rootScope"] }] */
  const vm = this;
  const store = $rootScope.reduxStore;
  const { dispatch, getState } = store;
  const { checkIfType } = utils;

  vm.previousLocation = null;
  vm.selectedLocation = null;
  /**
   * Expected to be in YYYY-MM-DD format.
   * Will come from service as a Date and be immediately converted.
   */
  vm.selectedDate = null;
  vm.selectedTime = undefined;
  vm.selectedPartySize = null;
  vm.collections = [];
  vm.query = { type: 'query', value: '' };
  vm.reservationLimit = null;
  vm.nearbyTranslation = 'Nearby';

  vm.onClear = onClear;
  vm.onPillSelect = onPillSelect;
  vm.showAuthModal = showAuthModal;
  vm.setQueuedData = setQueuedData;
  vm.getQueuedData = getQueuedData;

  vm.searchProps = $rootScope.searchProps;
  vm.searchPageSelectors = $rootScope.searchPageSelectors;
  vm.store = $ngRedux;

  onInit();

  function onInit() {
    setupReactors();
    loadLocation();
    loadDate();
    loadFavorites();
    loadPartySize();
    loadReservationLimit();
    loadNearbyTranslation();
    processRouteParams($route.current.params);
  }

  const onMultipleSliceChange = async ({ favorite, collections }) => {
    vm.favoriteVenueIds = favorite.venueIds;

    const { all } = collections.lists;
    const key = `${vm.selectedLocation?.code}-1-${selectIsAuthenticated(getState())}`;
    if (vm.selectedLocation?.code && all[key]) {
      vm.collections = await processCollections(all[key].all);
    }
    defer(() => $scope.$apply());
  };

  const unsubscribeMultipleSlice = observeStore(
    store,
    ({ favorite, collections }) => ({ favorite, collections }),
    onMultipleSliceChange
  );

  const onResyLocationsChange = (resyLocations) => {
    const { selected: location, previouslySelected: previousLocation } = resyLocations;
    if (location?.code !== vm.previousLocation?.code) {
      if (previousLocation) {
        vm.previousLocation = previousLocation;
      }

      if (location) {
        if (location.url_slug !== $routeParams.location || location.translationKey === 'nearby') {
          $route.updateParams({ location: location.url_slug });
        } else if ((previousLocation && previousLocation.translationKey === 'nearby')) {
          $route.reload();
        }

        // Reset, but only if location is already set (not on initial load)
        if (vm.selectedLocation && location.translationKey && location.translationKey !== 'nearby') {
          $location.search('query', null);
          $location.search('facet', null);
          $location.search('list', null);
        }

        vm.selectedLocation = location;
        buildPageTitle(vm.selectedLocation.name);
      }
      defer(() => $scope.$apply());
    }
  };
  const observeResyLocationsSlice = initObserveStore(store, ({ resyLocations }) => (resyLocations));
  const unsubscribeResyLocationsSlice = observeResyLocationsSlice(onResyLocationsChange);

  const onResyCoreSliceChange = (resyCoreSlice) => {
    const { selectedCoreISODate, selectedCoreSeats, selectedCoreTime } = resyCoreSlice;

    // SELECTED_TIME_UPDATED handling
    if (vm.selectedTime !== selectedCoreTime) {
      vm.selectedTime = selectedCoreTime;
      $rootScope.searchProps = {
        ...$rootScope.searchProps,
        selectedTime: selectedCoreTime,
      };
    }

    // SELECTED_DATE_UPDATED handling
    // vm.selectedDate is in ISO Date format
    if (vm.selectedDate !== selectedCoreISODate) {
      vm.selectedDate = selectedCoreISODate;
    }

    // PARTY_SIZE_SELECTED_UPDATED handling
    if (vm.selectedPartySize !== selectedCoreSeats) {
      vm.selectedPartySize = selectedCoreSeats;
      $rootScope.searchProps = {
        ...$rootScope.searchProps,
        selectedSeats: selectedCoreSeats,
      };
    }
    defer(() => $scope.$apply());
  };
  const observeResyCoreSlice = initObserveStore(store, ({ resyCore }) => (resyCore));
  const unsubscribeResyCoreSlice = observeResyCoreSlice(onResyCoreSliceChange);

  function onPillSelect() {
    $location.search('facet', null);
    $location.search('list', null);
    $rootScope.$apply();
  }

  function setQueuedData(payload) {
    if (payload) {
      Object.keys(payload).map((key) => {
        $location.search(key, payload[key]);
        return true;
      });
    }
  }

  function getQueuedData(keys) {
    let payload = null;
    keys.map((key) => {
      const search = $location.search();
      const val = search[key];
      if (val) {
        $location.search(key, null);
        payload = {
          ...payload,
          [key]: val,
        };
      }
      return true;
    });
    return payload;
  }

  function onClear() {
    $location.search('query', null);
    $location.search('facet', null);
    $location.search('list', null);
    $location.path(`/cities/${$routeParams.location}/search`);
    $rootScope.$apply();
  }

  function setupReactors() {
    $scope.$on('$destroy', () => {
      unsubscribeMultipleSlice();
      unsubscribeResyCoreSlice();
      unsubscribeResyLocationsSlice();
    });

    $rootScope.$on('$routeChangeStart', () => {
      if (vm.selectedLocation && vm.selectedLocation.translationKey === 'nearby') {
        const params = {
          location: vm.previousLocation,
          $rootScope,
          $window,
        };
        dispatch(setSelectedLocationThunk(params));
      }
    });

    $rootScope.$on('$routeChangeSuccess', (e, current) => {
      processRouteParams(current.params);
    });

    $rootScope.$on('$routeUpdate', (e, current) => {
      processRouteParams(current.params);
    });
  }

  function loadLocation() {
    const location = dispatch(getResyLocationsSelectedThunk());
    if (location) {
      if (location.url_slug !== $routeParams.location) {
        $route.updateParams({ location: location.url_slug });
      }
      vm.selectedLocation = location;
      buildPageTitle(vm.selectedLocation.name);
      defer(() => $scope.$apply());
    }
  }

  function processCollections(collections) {
    if (!collections) return [];
    return collections?.map((list) => ({
      id: list.id,
      collectionSlug: list.info.collection_slug,
      type_id: list.info.type_id,
      name: list.info.name,
      shortName: list.info.short_name,
      description: list.info.description,
      icon: {
        name: list.info.file_name,
        path: list.info.image,
      },
      isSelected: $routeParams.list === `collection_${list.id}`,
      urlSlug: `collection_${list.id}`,
    }));
  }

  function processRouteParams(params) {
    if (!!params.seats && checkIfType.isString(params.seats)) {
      vm.selectedPartySize = +params.seats;
      dispatch(setSelectedCoreSeats(vm.selectedPartySize));
    }

    if (!!params.time && checkIfType.isString(params.time)) {
      vm.selectedTime = params.time || ALL_DAY;
      dispatch(setSelectedCoreTime(vm.selectedTime));
    }

    if (!!params.date && checkIfType.isString(params.date)) {
      vm.selectedDate = params.date;
    } else {
      vm.selectedDate = moment().format(ISO_DATE_FORMAT);
    }
    dispatch(setSelectedCoreISODate(vm.selectedDate));

    if (params.list) {
      vm.query = {
        type: 'collection',
        value: params.list,
      };
    } else if (params.query) {
      vm.query = {
        type: 'query',
        value: params.query,
      };
    } else if (params.facet) {
      vm.query = {
        type: 'facet',
        value: params.facet,
      };
    } else {
      vm.query = { type: 'query', value: '' };
    }
  }

  function loadDate() {
    vm.selectedDate = dispatch(getSelectedCoreISODateThunk());
  }

  function loadFavorites() {
    if (selectIsAuthenticated(getState())) {
      dispatch(getFavoriteVenues());
    }
  }

  function loadPartySize() {
    vm.selectedPartySize = dispatch(getSelectedCoreSeatsThunk());
  }

  function loadReservationLimit() {
    if ($rootScope.matchMedia.md) {
      vm.reservationLimit = 4;
    } else if ($rootScope.matchMedia.xs) {
      vm.reservationLimit = 3;
    } else {
      vm.reservationLimit = 2;
    }
  }

  function buildPageTitle(locationName) {
    $rootScope.metadata.title = getTranslation({
      translationKey: 'titles.search_market',
      translationValues: { locationName },
      fallback: `Discover ${locationName} Restaurants to Love on Resy`,
    });

    $rootScope.metadata.description = getTranslation({
      translationKey: 'descriptions.search_market',
      translationValues: { locationName },
      fallback: `Looking for the best bars, brunch spots, and everything in between? Search our curated collections for ${locationName} restaurants and book them right on Resy.`,
    });
  }

  function loadNearbyTranslation() {
    $translate('nearby')
      .then((translation) => {
        vm.nearbyTranslation = translation;
      })
      .catch(angular.noop);
  }

  function showAuthModal() {
    $rootScope.$broadcast('MODAL', 'signin');
  }
}

export default () => {};
